<template>

    <el-row :gutter="20">
        <el-col :span="12">
            <div class="details-title">Host (main)</div>
            <p>{{ feed.zixi_conf.host_main_ip || 'NO DATA'}}</p>
        </el-col>
        <el-col :span="12">
            <div class="details-title">Host (backup)</div>
            <p>{{ feed.zixi_conf.host_backup_ip || 'NO DATA'}}</p>
        </el-col>
        <el-col :span="12">
            <div class="details-title">Port</div>
            <p>{{ feed.zixi_conf.port || 'NO DATA'}}</p>
        </el-col>
        <el-col :span="24" v-if="feed.source_protocol_type != 'srt'">
            <div class="details-title">Stream ID</div>
            <p>{{ feed.zixi_conf.stream_id || 'NO DATA'}}</p>
        </el-col>
        <el-col :span="24">
            <div class="manual-pull-style zixi-conf-info">
                <div class="manual" v-if="feed.source_protocol_type != 'srt'">manual pull</div>
                <div class="decryption">
                    <div class="decryption-label">Encryption type</div>
                    <div class="decryption-value">{{ feed.zixi_conf.encryption_type || 'NO DATA' }}</div>
                </div>
                <div class="key">
                    <div class="key-label">Encryption key</div>
                    <div class="buttons">
                        <el-button
                            class="decryption-see"
                            :disabled="!feed.zixi_conf.encryption_type"
                            @click="showKey"
                        >
                            <i class="el-icon-view"></i>
                            See
                        </el-button>
                        <el-button
                            class="decryption-copy"
                            :disabled="!feed.zixi_conf.encryption_type"
                            @click="copyEncryptionKey"
                        >
                            <span class="copy-icon"></span>
                            Copy
                        </el-button>
                    </div>
                </div>
            </div>
        </el-col>
        <el-dialog
            title="Encryption key"
            custom-class="key-modal"
            :visible.sync="showKeyModal"
            width="230px"
            :show-close="false"
            append-to-body
            @close="showKeyModal = false">
            <div class="key-value">{{ feed.zixi_conf.encryption_key }}</div>
            <span slot="footer">
                <el-button class="key-modal-button exit-button" @click="showKeyModal = false">Done</el-button>
                <el-button class="key-modal-button copy-button" type="primary" @click="copyEncryptionKey"><span class="copy-icon"></span>Copy</el-button>
            </span>
        </el-dialog>
    </el-row>
</template>

<script>

export default {

    components: {

    },

    props: {
        feed: {
            required: true,
            type: Object,
        },
    },

    data (){
        return {
            showKeyModal: false,
        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
        showKey() {
            this.showKeyModal = true;
        },
        copyEncryptionKey (){
            const el = document.createElement('textarea');
            el.value = this.feed.zixi_conf.encryption_key;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        },
    },
};
</script>

<style lang="scss">
.manual-pull-style.zixi-conf-info{
    background: linear-gradient(180deg, #000 -14.18%, rgba(34,34,34,0) 100%);
    .manual, .decryption-label, .key-label{
        font-size: 14px;
    }
    .decryption-label, .key-label{
        font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Feeds/feed-source-external-info.vue